module.exports = __webpack_public_path__ + "img/background028.jpg";